// extracted by mini-css-extract-plugin
export default {"label":"tracker-details_label__fgAQK","attribute":"tracker-details_attribute__ioE+n"};